import React from 'react';
import MainComponent from "../../component/main";
import NosotrosComponent from "../../component/nosotros";
import Informacion from "../../component/informacion";
import SucursalesComponent from "../../component/sucursales";
import ContactComponent from "../../component/contacto";
import Retirement from '../../component/retirement';

const namespace = 'expreso-el-vasquito';

function Home(props) {
	return(
		<div className={namespace}>
			<MainComponent
        page={props.page}
      />
			<NosotrosComponent />
			<Retirement/>
			<Informacion />
			<SucursalesComponent />
			<ContactComponent />
		</div>
	);
}

export default Home;